<tt-page *ngIf="!!setting">
    <div class="col-xs-12 sp-0 height-full" *ngIf="'mobile' | mediaQuery">
        <div *ngIf="setting.show_grid === '0'">
            <ng-container *ngTemplateOutlet="buttons"></ng-container>
            <ng-container *ngTemplateOutlet="list"></ng-container>
        </div>

        <div class="height-full" *ngIf="setting.show_grid === '1'">
            <ng-container *ngTemplateOutlet="gridList"></ng-container>
        </div>
    </div>

    <div class="height-full" *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <div *ngIf="setting.show_grid === '0'">
            <ng-container *ngTemplateOutlet="buttons"></ng-container>
            <ng-container *ngTemplateOutlet="list"></ng-container>
        </div>

        <div class="height-full" *ngIf="setting.show_grid === '1'">
            <ng-container *ngTemplateOutlet="gridList"></ng-container>
        </div>
    </div>

    <tt-card class="col-xs-12 sp-0" *ngIf="setting.show_setting === '1'">
        <tt-button-settings></tt-button-settings>
    </tt-card>
</tt-page>

<ng-template #buttons>
    <ng-container *ngIf="!!setting">
        <tt-card>
            <tt-button-goto [ttText]="'custactdeadline_new'" (ttClick)="goToFunc('custactedit')" ttIcon="fa fa-solid fa-plus"></tt-button-goto>
        </tt-card>
    </ng-container>
</ng-template>

<ng-template #list>
    <ng-container *ngIf="!!setting">
        <tt-list [ttData]="itemsListDeadLines"></tt-list>
    </ng-container>
</ng-template>

<ng-template #gridList>
    <ng-container *ngIf="!!setting">
        <tt-grid *ngIf="!!grid" class="flex-1" [(ttOptions)]="grid"></tt-grid>
    </ng-container>
</ng-template>
